module.exports = __webpack_public_path__ + "img/slovenia-logo-icon.4e43711f.png";